var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-popup-fullscreen',{attrs:{"module":"quizPreviewPopup","open":_vm.handleOpen,"close":_vm.handleClose}},[(_vm.customQuizId !== '')?_c('quiz-preview-2',{ref:"quizPreview",attrs:{"isPreview":_vm.isPreview}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }